import { render, staticRenderFns } from "./SavedListGridItem.vue?vue&type=template&id=6a15ed51&"
import script from "./SavedListGridItem.vue?vue&type=script&lang=js&"
export * from "./SavedListGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports